import React, { useRef, useEffect } from 'react'
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import banner from "../../Assests/images/home_images/Channel-Patrners-image.jpg"
import mobileBanner from "../../Assests/images/home_images/Channel-Partners-image-mobile.jpg"
import { LazyLoadImage } from 'react-lazy-load-image-component';

const Banner = () => {
    const headRef = useRef(null);
    useEffect(() => {
        if (window.location.hash === '#head') {
            headRef.current?.scrollIntoView({ behavior: 'smooth' });
        }
    }, []);
    return (
        <header className="banner">
            <LazyLoadImage
                src={banner}
                alt="Desktop Banner Image"
                className="banner-image h-100 desktop-banner"
                style={{ filter: 'brightness(0.6)' }} 
            />
            <LazyLoadImage
                src={mobileBanner}
                alt="Mobile Banner Image"
                className="banner-image h-100 mobile-banner"
                style={{ filter: 'brightness(0.6)' }} 
            />
            <div className="banner-text w-100">
                <div className="heading-title d-flex flex-column gap-5">
                    <h1 className="title text-white text-center ">Welcome to CoOwnSpace<br></br>
                    Partner with Us for Real Estate Growth</h1>
                    {/* <div>
                        <p className='title text-white text-center mb-4 h3'>Affordable Real Estate Investment Made Easy!</p>
                        <p className="h6 fw-4 text-white text-center mb-4">India's Trusted Platform for Smart Fractional Ownership and Real Estate Investment</p>
                    </div> */}
                </div>
            </div>
        </header>
    )
}

export default Banner;